<template>
  <div class="space-y-2">
    <div class="brand-card-lg" id="custom-attributes">
      <CustomAttributeEditor />
    </div>
    <div class="brand-card-lg" id="redemption">
      <OfferRedemptionEditor />
    </div>
    <div v-can-show="'cf:write'" class="brand-card-lg" id="managed-flow" v-if="orgSupportsManagedFlow">
      <EmailBasedFlowEditor />
    </div>
    <div class="brand-card-lg" id="plan">
      <OrgPaymentProviderSettings />
    </div>
    <div class="brand-card-lg">
      <OrgTranslationEditor id="translation" />
    </div>
  </div>
</template>

<script>
import CustomAttributeEditor from '@/components/UI/CustomAttributeEditor.vue';
import OfferRedemptionEditor from '@/components/UI/OfferRedemptionEditor.vue';
import OrgPaymentProviderSettings from '@/components/Settings/OrgPaymentProviderSettings.vue';
import OrgTranslationEditor from '@/components/UI/OrgTranslationEditor.vue';
import EmailBasedFlowEditor from '@/components/UI/EmailBasedFlowEditor.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'CancellationAdvancedSettings',
  components: {
    OfferRedemptionEditor,
    CustomAttributeEditor,
    OrgTranslationEditor,
    OrgPaymentProviderSettings,
    EmailBasedFlowEditor,
  },
  computed: {
    ...mapGetters(['orgSupportsManagedFlow']),
  },
  mounted() {
    // allow to link to specific sections of the page
    const scrollWhiteList = ['redemption', 'managed-flow', 'custom-attributes', 'plan', 'translation'];
    if (this.$route.query.focus && scrollWhiteList.includes(this.$route.query.focus)) {
      const el = document.getElementById(this.$route.query.focus);
      el.scrollIntoView({ behavior: 'smooth' });
    }
  },
};
</script>
